import React, { useEffect, useState } from "react";
import SettlementFormModal from "./SettlementFormModal";

const EditSettlementButton = ({
  columnData,
  updateAtmedSettlementsDoctorConsultation,
  getAllAtmedSettlementsDoctorConsultation,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState(false);

  const showModal = () => {
    setModalVisible(true);
  };
  const hideModal = () => {
    setModalVisible(false);
  };
  const onSubmit = async (data) => {
    const payloadObj = {
      id: columnData.id,
      payload: { consultation_booking: data },
    };
    hideModal();
    await updateAtmedSettlementsDoctorConsultation(payloadObj);
    await getAllAtmedSettlementsDoctorConsultation(undefined, 20, 1);
  };

  useEffect(() => {
    setFormData(columnData);
  }, [modalVisible]);

  return (
    <>
      <SettlementFormModal
        data={formData}
        onSubmit={onSubmit}
        onCancel={hideModal}
        visible={modalVisible}
        title={`Update Settlement Status - ${columnData.booking_id}`}
        keyName={"consultation_booking"}
        updateAtmedSettlementsDoctorConsultation={
          updateAtmedSettlementsDoctorConsultation
        }
        getAllAtmedSettlementsDoctorConsultation={
          getAllAtmedSettlementsDoctorConsultation
        }
        id={columnData.id}
        submitText="Update"
      />
      <div onClick={showModal}> Edit Status</div>
    </>
  );
};
export default EditSettlementButton;
